// extracted by mini-css-extract-plugin
module.exports = {"image":"Start_image__3UI9h","description":"Start_description__qC8uy","ageInput":"Start_ageInput__2gGyD"};